import HoverImage from "../assets/images/hover-icon.png";

type HoverBlockProps = {
  marginBottom?: string | "0px";
  description?: string;
  setShowModal?: React.Dispatch<React.SetStateAction<boolean>>;
};

const HoverBlock = ({
  marginBottom,
  description,
  setShowModal,
}: HoverBlockProps) => {
  const onClickHandler = () => {
    setShowModal?.(true);
  };
  return (
    <div
      className="btn-hover-div-pre-footer"
      style={{marginBottom: marginBottom}}>
      <button onClick={onClickHandler}>
        <img src={HoverImage} />
        {description}
      </button>
    </div>
  );
};

export default HoverBlock;
